import axios from 'axios';
import { BASE_URL } from '@/assets/js/config';
import { getAccessToken } from '@/assets/js/auth';

export const getDNSZones = async (apiUrl, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/v2/zones/`, settings);
}

export const getDNSZoneDetails = async (apiUrl, DNSZoneId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/v2/zones/${DNSZoneId}`, settings);
}

export const createDNSZone = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.post(`${apiUrl}/v2/zones`, data, settings);
}

export const deleteDNSZone = async (apiUrl, DNSZoneId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.delete(`${apiUrl}/v2/zones/${DNSZoneId}`, settings);
}

export const getDNSZoneRecords = async (apiUrl, DNSZoneId, nextUrl, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  if (nextUrl) {
      return axios.get(`${nextUrl}`, settings);
  } else {
      return axios.get(`${apiUrl}/v2/zones/${DNSZoneId}/recordsets`, settings);
  }
}

export const createDNSRecord = async (apiUrl, data, DNSZoneId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.post(`${apiUrl}/v2/zones/${DNSZoneId}/recordsets`, data, settings);
}

export const getDNSRecordDetails = async (apiUrl, DNSZoneId, DNSRecordId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/v2/zones/${DNSZoneId}/recordsets/${DNSRecordId}`, settings);
}

export const editDNSRecord = async (apiUrl, DNSZoneId, DNSRecordId, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.put(`${apiUrl}/v2/zones/${DNSZoneId}/recordsets/${DNSRecordId}`, data, settings);
}

export const deleteDNSRecord = async (apiUrl, DNSZoneId, DNSRecordId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.delete(`${apiUrl}/v2/zones/${DNSZoneId}/recordsets/${DNSRecordId}`, settings);
}

export const getReversDNS = async (apiUrl, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/v2/reverse/floatingips`, settings);
}

export const getFixedReversDNS = async (apiUrl, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/v2/reverse/fixedips`, settings);
}

export const setFipPtr = async (apiUrl, fipId, data, region, fixedIp) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  if (region === 'core') {
        region = 'ams2';
  }
  if (fixedIp) {
    return axios.patch(`${apiUrl}/v2/reverse/fixedips/${region}:${fipId}`, data, settings)
  } else {
    return axios.patch(`${apiUrl}/v2/reverse/floatingips/${region}:${fipId}`, data, settings)
  }
}

export const requestDNSZone = async (data) => {
  const teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.post(`${BASE_URL}/api/notify`, data, settings)
}